<app-header [sections]="sections">
</app-header>
<main class="inm-layout-main">
    <router-outlet (activate)="routeChanged()"></router-outlet>
</main>
<app-footer></app-footer> 

